import { render, staticRenderFns } from "./PembatalanTrxView.vue?vue&type=template&id=4fba6503&scoped=true"
import script from "./PembatalanTrxView.vue?vue&type=script&lang=js"
export * from "./PembatalanTrxView.vue?vue&type=script&lang=js"
import style0 from "./PembatalanTrxView.vue?vue&type=style&index=0&id=4fba6503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba6503",
  null
  
)

export default component.exports